<h2 mat-dialog-title>Update to Job Started</h2>

<form [formGroup]="form">
  <mat-dialog-content>
    <div class="flex flex-col items-stretch">
      <mat-form-field
        class="w-full"
        [testId]="testIds.REPAIR_STARTED_NOTES_INPUT"
      >
        <mat-label>Notes</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          [cdkAutosizeMinRows]="2"
          formControlName="notes"
        ></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      mat-flat-button
      mat-dialog-close
      [testId]="testIds.CANCEL_EVENT_DIALOG_BUTTON"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="saveWaitingForParts()"
      [disabled]="form.invalid"
      [testId]="testIds.SAVE_REPAIR_STARTED_BUTTON"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
